import React from 'react';
import { Alert, Spin } from 'antd';
import TextBlock from './blocks/TextBlock';
import ToolStatusBlock from './blocks/ToolStatusBlock';
import TableBlock from './blocks/TableBlock';
import ChartBlock from './blocks/ChartBlock';
import ProjectResultsBlock from './blocks/ProjectResultsBlock';

const renderBlock = (block, index) => {
  switch (block.type) {
    case 'text':
      return <TextBlock key={index} text={block.text} />;
    case 'tool':
      return <ToolStatusBlock key={index} label={block.label} status={block.status} />;
    case 'table':
      return <TableBlock key={index} title={block.title} columns={block.columns} rows={block.rows} />;
    case 'chart':
      return <ChartBlock key={index} spec={block.spec} />;
    case 'projects':
      return (
        <ProjectResultsBlock
          key={index}
          title={block.title}
          payload={block.payload}
          filters={block.filters}
        />
      );
    default:
      return null;
  }
};

const Message = ({ message, isStreaming }) => {
  if (message.role === 'user') {
    return (
      <div className="agent-message agent-message-user">
        <div className="agent-message-bubble">{message.text}</div>
      </div>
    );
  }

  const isEmpty = message.blocks.length === 0 && !message.error;
  return (
    <div className="agent-message agent-message-assistant">
      {message.blocks.map(renderBlock)}
      {/* Stays visible for the whole turn. It used to show only while the
          message was still empty, so it disappeared as soon as the first tool
          block arrived — exactly when the long waits start and the user has no
          sign that anything is still happening. */}
      {isStreaming && !message.error && (
        <div className="agent-thinking">
          {isEmpty ? (
            <>
              <Spin size="small" />
              <span>Denke nach…</span>
            </>
          ) : (
            <span className="agent-typing-dots" aria-label="Arbeitet noch">
              <i />
              <i />
              <i />
            </span>
          )}
        </div>
      )}
      {message.error && (
        <Alert
          type="error"
          showIcon
          message="Fehler"
          description={message.error}
          style={{ marginTop: 8 }}
        />
      )}
    </div>
  );
};

const MessageList = ({ messages, isStreaming }) => (
  <>
    {messages.map((message, index) => (
      <Message
        key={message.id}
        message={message}
        isStreaming={isStreaming && index === messages.length - 1}
      />
    ))}
  </>
);

export default MessageList;
